"use client"
import { ColumnDef } from "@tanstack/react-table"
import { ArrowUpDown } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import CustomerRowActions from "./CustomerRowActions"
import { format } from "date-fns"

export type Customers = {
    id: string
    name: number
    description: string
    status: number
    slug: Date
    created_at: Date
    updated_at: Date
}

interface rowActionProps {
    onEdit: (data: any) => void;
    onDelete: (data: any) => void;
    roles: string[]
}
export const customersColumns = ({ onEdit, onDelete, roles }: rowActionProps): ColumnDef<Customers>[] => {
    const columns: ColumnDef<Customers>[] = [

        {
            accessorKey: "id",
            header: "Id",
        },
        {
            accessorKey: "name",
            header: "Name",
        },
        {
            accessorKey: "description",
            header: "Description",
        },
        {
            accessorKey: "status",
            header: "status",
            cell: ({ row }) => {
                const value: any = row.original
                const statusText = value.status === 1 ? "Active" : "InActive";
                const bgColor = value.status === 1 ? "bg-green-500" : "bg-red-500";

                return (
                    <span className={`px-2  rounded-full ${bgColor} text-white`}>
                        {statusText}
                    </span>
                );
            },
        },
        {
            accessorKey: "created_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Created At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const formattedDate = format(new Date(row.original.created_at), 'yyyy-MM-dd HH:mm:ss');
                return <span>{formattedDate}</span>;
            },
        },
        {
            accessorKey: "updated_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Updated At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const formattedDate = format(new Date(row.original.updated_at), 'yyyy-MM-dd HH:mm:ss');
                return <span>{formattedDate}</span>;
            },
        },


    ]
    if (roles.includes('customer-delete') || roles.includes('customer-edit')) {
        columns.push({
            id: "actions",
            header: 'Actions',
            cell: ({ row }) => <CustomerRowActions row={row} onEdit={onEdit} onDelete={onDelete} roles={roles} />,
        })
    }

    return columns
}
